import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Objects } from '../../../util/objects';

@Component({
  selector: 'ngx-user-link-column',
  template: `
    <nb-icon *ngIf="useSearch" icon="search-outline" status="primary" class="pointer" (click)="onSearch()"></nb-icon>
    <span (click)="onClick()" style="cursor: pointer; font-weight: bold; color: #00d68f">{{ params.value }}</span>
    `,
  encapsulation: ViewEncapsulation.None,
})
export class UserLinkComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public useSearch: boolean = false;

  constructor(private router: Router) {}

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;

    if (this.params.hasOwnProperty('useSearch'))
      this.useSearch = Objects.safeGetValue(this.params, 'useSearch', false);
  }

  ngOnInit() {}

  onClick(): void {

    let user: any = null;
    if (this.params.hasOwnProperty('userPath')) {
      user = Objects.safeGetValue(this.params.data, this.params['userPath']);
    } else {
      user = this.params.data.user;
    }

    if (!user) return;

    this.router.navigate([`pages/user/${user.id}`]);
  }

  onSearch(): void {
    let user: any = null;
    if (this.params.hasOwnProperty('userPath')) {
      user = Objects.safeGetValue(this.params.data, this.params['userPath']);
    } else {
      user = this.params.data.user;
    }

    if (!user) return;

    this.params.context.clickUser(user.id);
  }
}
